<template>
  <div class="v-tooltip" ref="root" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot>
      <v-icon class="v-tooltip__icon" outlined>
        {{ icon }}
      </v-icon>
    </slot>

    <Teleport to="body">
      <div class="v-tooltip__tooltip" ref="tooltip" v-if="visible && text">
        {{ text }}
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: null },
    icon: { type: String, default: 'info' },
    width: { type: String, default: '20em' },
    size: { type: String, default: '1.25em' },
    offsetX: { type: Number, default: 0 },
    offsetY: { type: Number, default: 2 }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    showTooltip() {
      this.visible = true;
      this.$nextTick(this.updateTooltipPosition);
    },
    hideTooltip() {
      this.visible = false;
    },
    updateTooltipPosition() {
      const triggerRect = this.$refs.root.getBoundingClientRect();
      const tooltip = this.$refs.tooltip;
      if (tooltip?.style)
        Object.assign(tooltip.style, {
          top: `${triggerRect.top + window.scrollY - this.offsetY}px`,
          left: `${triggerRect.right + window.scrollX - this.offsetX}px`,
          transform: 'translate(-100%, -100%)'
        });
      // It opens to the left of the icon: when the icon sits near the left edge
      // of the screen, shift it right so it stays within the viewport.
      const margin = 8;
      const { left } = tooltip?.getBoundingClientRect() ?? {};
      if (left < margin) {
        tooltip.style.left = `${parseFloat(tooltip.style.left) + margin - left}px`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-tooltip {
  display: inline-block;
  position: relative;
  line-height: 1;
  &__icon {
    cursor: pointer;
    font-size: v-bind(size);
    font-weight: 500;
    color: $cmain;
    vertical-align: middle;
  }
  &__tooltip {
    position: absolute;
    max-width: min(v-bind(width), calc(100vw - 16px));
    background-color: #000a;
    color: white;
    padding: 8px;
    border-radius: 0.5em;
    white-space: nowrap;
    z-index: 1000;
    font-size: 14px;
    transition: opacity 0.2s;
    white-space: normal;
    line-height: 1.5;
  }
}
</style>
